<template>
    <div class="contentArea pt-0">


        <Content_component/>

    </div>
</template>

<script>
    
    import Content_component from "./elements/content/Content_component.vue"
  
    export default {
        components:{
            Content_component
        },
        // async mounted(){
        //     await this.$store.dispatch("general/get_banner")
        // },
        // computed: {
        //     ...mapGetters({
        //         language: "general/language"
        //     })

        // }
    }
   
</script>

<style lang="scss" >

</style>